<template>
    <layout>
        <template slot="content">
            <header class="content__title">
                <h1>{{ title }}</h1>
            </header>
            <list v-bind="listData"></list>
        </template>
    </layout>
</template>

<script>
    import Index from '@/pages/Index'
    import List from '@/components/ProductList'

    export default {
        extends: Index,

        components: {
            'list': List
        }
    }
</script>